
















import { Vue, Component } from 'vue-property-decorator';
import { rule } from '../api/rule';
@Component
export default class Rule extends Vue {
  activeIndex = 0;
  tabs = [
    {
      text: '活动背景',
      id: 1,
    },
    {
      text: '组织机构',
      id: 2,
    },
    {
      text: '活动亮点',
      id: 6,
    },
    {
      text: '奖项设置',
      id: 3,
    },
    {
      text: '参评条件',
      id: 4,
    },
    {
      text: '评选流程',
      id: 5,
    },
  ];
  get content() {
    return rule[this.tabs[this.activeIndex].id];
  }
  classArr(index: number) {
    if (index === this.activeIndex) {
      return ['tab-item', 'tab-item-active'];
    }
    return ['tab-item'];
  }
}
